import { Box, Flex, Image as ImageComponent, Text } from '@chakra-ui/react';
import Head from 'next/head';
import router from 'next/router';
import React, { useState } from 'react'
import { AboutCard } from '../../components/AboutUs/aboutCard';
import { BreadCrumb } from '../../components/AppHeader/BreadCrumb';
import { AuthModal } from '../../components/Auth/withAuthModal';
import { PerformanceBanner, RatingBanner, UploadListingBanner } from '../../components/Banner';
import { PrimaryButton } from '../../components/button';
import { TrustedCompanies } from '../../components/Landing';
import { professionalFaq } from '../../data';
import { otherListingProperties, otherListingPropertiesTools } from '../../data/business-owners';
import { WrapperStyle } from '../../styles/newDesignStyles';
import { HeaderText, RealtorsHeader, RealtorsSemiHeader, SemiHeaderText } from '../../styles/typography';
import { useAuth } from '../../utils/auth/newAuth';

const BusinessOwners = () => {

    const [isAuthBoxOpen, setisAuthBoxOpen] = useState(false);
    const { user } = useAuth();

    return (
        <>

            <Head>
                <title key="title">Business Owners - Business and Commercial Real Estate Listings</title>
                <meta key="description" name="description" content="List your business where the right buyers are looking. Send in-built NDAs to keep information safe. Deal with serious buyers. List for free." />
                <meta key="og:title" property="og:title" content='Business Owners - Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="List your business where the right buyers are looking. Send in-built NDAs to keep information safe. Deal with serious buyers. List for free." />

                <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon.png" />
                <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="/favicons/favicon-32x32.png" />
                <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="/favicons/favicon-16x16.png" />
                <link key="fav5" rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#5bbad5" />
                <link key="fav6" rel="shortcut icon" href="/favicons/favicon.ico" />
                <link rel="canonical" href="https://zonado.com/who-we-help/business-owners" />
                <meta key="msFav" name="msapplication-TileColor" content="#2d89ef" />
                <meta name="msapplication-config" content="favicons/browserconfig.xml" />
                <meta name="theme-color" content="#ffffff" />

            </Head>

            <AuthModal
                createListing
                onClose={() => setisAuthBoxOpen(false)}
                isOpen={isAuthBoxOpen}
                
            />

            <WrapperStyle>

                {/* breadcrumb */}
                <BreadCrumb to={"Business owners"} />

                <Flex flexDir={{ base: "column", md: "row" }} mt={{ md: "0", lg: "50px" }} justifyContent={"space-between"} alignItems={"center"}>
                    <Flex
                        pt={{ base: "68px", md: "33px", lg: "26px" }}
                        pb={{ base: "0", lg: "26px" }}
                        flexDir={"column"} w={{ md: "40%", lg: "49%" }}

                    >
                        <HeaderText text={"Rise above the clutter of classifieds"} />
                        <SemiHeaderText
                            text={"Industry platforms don’t allow owners to list their business for sale, leaving you restricted and limited in reach. That’s history with Zonado."}
                        />

                        <PrimaryButton
                            mb={"36px"} label={"Add a Free Listing"}
                            mr={"auto"} mt={"43px"}
                            onClick={() => user ? router.push("/add-listing") : setisAuthBoxOpen(true)}
                        />

                    </Flex>

                    <Box w={{ md: "45%" }} py={"14px"} pr={"11px"}>
                        <ImageComponent src={"/images/newLanding/businessOwnerBanner.svg"} h={"100%"} objectFit={"contain"} w={["100%", "350px", "100%"]} mx={"auto"} />
                    </Box>
                </Flex>

                <Flex flexDir={"column"} mt={"50px"} >
                    <Text color={"gray.500"} fontSize={"16px"}>Trusted by</Text>

                    <Flex flexDir={"row"} mt={"23px"} className={"trustedCompanies"}>
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image_2.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 4.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/Vector.svg"} />
                        <TrustedCompanies img={"/images/newLanding/trustedCompanies/image 30.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 7.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 3.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 6.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 22.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 5.svg"} />
                        <TrustedCompanies className={"remove"} img={"/images/newLanding/trustedCompanies/image 8.svg"} />
                    </Flex>
                </Flex>

                <Box mt={"96px"}>
                    <RealtorsHeader
                        text={"Don’t leave money on the table when selling what you built"}
                    />
                    <RealtorsSemiHeader text={"Zonado helps business owners maximize reach among active buyers, realtors, business brokers. Sell with confidence on Zonado."}
                    />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingProperties.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* performance banner */}
                <PerformanceBanner />

                {/* broker tools  */}
                <Box>
                    <RealtorsHeader text={"A powerful suite of features built for your needs"} />
                    <RealtorsSemiHeader text={"Zonado was built as a result of intensive user interviews with business owners from across Canada. The result is a suite of elegant solutions to power your workflow"} />

                    <Flex mt={"56px"} flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-between"}>
                        {
                            otherListingPropertiesTools.map(({ id, ...rest }) =>
                                <AboutCard
                                    key={id}
                                    item={rest}
                                />
                            )
                        }
                    </Flex>
                </Box>

                {/* upload listing banner */}
                <UploadListingBanner
                    bannerBody={<>Upload a flyer/listing details & photos and we will put up your listing for you in less than 24 hours, <strong>free</strong>.</>}
                    bannerHeader={"Let us upload your listing for you"}
                    bannerImage={"/images/newLanding/uploadListingBusinessOwners.png"}
                />

                {/* ratings banner */}
                <RatingBanner
                    ratingImg={"/images/newLanding/businessOwnersTestimony.png"}
                    ratingHeader={'Awesome service'}
                    review={<>I spoke to the team at Zonado to post my business for sale, they helped me by creating  great content, great service,
                        <br />Absolutely the best at what they do</>}
                    reviewer={"- Barberholic Barber (Ottawa)"}
                />

            </WrapperStyle>
        </>
    )
}

export default BusinessOwners


BusinessOwners.isProfessional = true;
BusinessOwners.faq = professionalFaq;